module.exports = __webpack_public_path__ + "static/media/towerDefensePhilipp.5778736e.jpg";